import { render, staticRenderFns } from "./Receivingprintdetails.vue?vue&type=template&id=35ba3974&scoped=true&"
import script from "./Receivingprintdetails.vue?vue&type=script&lang=js&"
export * from "./Receivingprintdetails.vue?vue&type=script&lang=js&"
import style0 from "./Receivingprintdetails.vue?vue&type=style&index=0&id=35ba3974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba3974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ba3974')) {
      api.createRecord('35ba3974', component.options)
    } else {
      api.reload('35ba3974', component.options)
    }
    module.hot.accept("./Receivingprintdetails.vue?vue&type=template&id=35ba3974&scoped=true&", function () {
      api.rerender('35ba3974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/Receivingprintdetails.vue"
export default component.exports